import {
    getImportedAccountMappingResolution,
    ImportedAccountMappingResolution,
} from "@common/helpers/importedAccountMappingResolution";
import { CoaMappingRow } from "./coaMappingRowTypes";

export interface UnmappedMappingRow {
    rowId: string;
    name: string;
}

export function collectUnmappedMappingRows(
    rows: CoaMappingRow[],
): UnmappedMappingRow[] {
    return rows.flatMap((row) => {
        if (row.account) {
            const isUnmapped =
                getImportedAccountMappingResolution({
                    account: row.account,
                }) === ImportedAccountMappingResolution.UNMAPPED;
            return isUnmapped ? [{ rowId: row.id, name: row.name }] : [];
        }
        return collectUnmappedMappingRows(row.children ?? []);
    });
}
